/**
 * O tipo do componente do diagrama, pelo nome.
 *
 * **Os tipos são os do legado** (`Diagrama_componente.Tipo()`), gravados como
 * número em `diagrama_componente.tipo`. Antes a ficha pedia o número cru, e
 * ninguém lembra que 2 é Sinal e 6 é Sinal na posição de componente.
 *
 * O título continua texto livre, como no legado: nos tipos Fusível e Sinal é
 * ele que o desenho põe dentro da caixa ou da elipse ("+15", "30").
 */

export const TIPOS_DO_COMPONENTE: [number, string][] = [
  [0, "Normal"],
  [1, "Fusível"],
  [2, "Sinal"],
  [3, "Jump"],
  [4, "Nota"],
  [5, "Aterramento"],
  [6, "Sinal na posição de componente"],
  [7, "Normal obrigatório"],
  [8, "Fusível na posição de componente"],
  [9, "Diagrama vinculado acima"],
  [10, "Diagrama vinculado abaixo"],
  [11, "Malha acima"],
  [12, "Malha abaixo"],
  [13, "Linha"],
  [14, "Texto do componente principal"],
]

export function SeletorDeTipo({ valor, aoMudar, estilo }: {
  valor: number
  aoMudar: (tipo: number) => void
  estilo?: React.CSSProperties
}) {
  const conhecido = TIPOS_DO_COMPONENTE.some(([v]) => v === valor)
  return (
    <select value={valor} onChange={(e) => aoMudar(Number(e.target.value))} style={estilo}>
      {/* Um número fora da lista ainda é o que está gravado: aparece, para não ser trocado calado. */}
      {!conhecido && <option value={valor}>Tipo {valor}</option>}
      {TIPOS_DO_COMPONENTE.map(([v, r]) => <option key={v} value={v}>{r}</option>)}
    </select>
  )
}
